import ACTIONS from '~shared/actions';
import { Grow2529Actions, Grow2529StateType } from './types';
import { Packages } from '~shared/constants/pricing';

export const grow2529State: Grow2529StateType = {
  toggleChecked: [Packages.FormsAnnual, Packages.StarterAnnual],
};

export default function Grow2529Reducer(state: Grow2529StateType, action: Grow2529Actions): Grow2529StateType {
  const { type, payload } = action;

  if (type === ACTIONS.FORMS_TOGGLE_SWITCH) {
    const newState = state.toggleChecked.filter(pkg => pkg !== payload.packageToBeReplaced);
    newState.push(payload.replacedWith);

    return {
      ...state,
      toggleChecked: newState,
    };
  }

  if (type === ACTIONS.FORMS_RESET_TOGGLE_SWITCH) {
    return {
      ...state,
      toggleChecked: [Packages.FormsAnnual, Packages.StarterAnnual],
    };
  }

  return state;
}
